import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrowForwards = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    viewBox="0 -960 960 960"
    {...props}
  >
    <path d="m480-160-42-43 247-247H160v-60h525L438-757l42-43 320 320-320 320Z" />
  </svg>
);
export default SvgArrowForwards;
